/*
 * @Author: hfxie
 * @Date: 2023-09-12 17:23:53
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-06-14 13:52:06
 * @Description: file content
 */
import axios from "axios";
import OutConst from "../customEventOutConst.js";
import CONSTNAME from "@/ConstName.js";
import * as utils from "@/utils/ganttUnit.js";
const action = {
  // 选中行
  demo(store, index) {
    console.log("demo action");
  },
  // 加载苍穹测试数据
  loadMockCq(store, index = "") {
    console.log("加载苍穹测试数据", "/api/" + index);
    axios({
      method: "post",
      url: "/api/" + index,
      data: {},
    })
      .then((res) => {
        if (res.data.success === true) {
          console.log("Mock:", res);
          store.commit("init", res.data.data);

        }
      });
  },
  // 初始化·主动发起数据加载
  [OutConst.CUSTOM_INIT](store, obj) {
    this._invoke(OutConst.CUSTOM_INIT, obj);
  },
  [OutConst.SELECT_ROW](store, row) {
    this.commit("set_detailId", row.id);
    this._invoke(OutConst.SELECT_ROW, row);
  },
  [OutConst.UPDATE_TREE_WIDTH](store, obj) {
    this._invoke(OutConst.UPDATE_TREE_WIDTH, obj);
  },
  [OutConst.UPDATE_HEADITEM_WIDTH](store, obj) {
    this._invoke(OutConst.UPDATE_HEADITEM_WIDTH, obj);
  },
};

export default action;
